import { render } from "./itemOnKdsSet.vue?vue&type=template&id=55699dd2"
import script from "./itemOnKdsSet.vue?vue&type=script&lang=js"
export * from "./itemOnKdsSet.vue?vue&type=script&lang=js"

import "./itemOnKdsSet.vue?vue&type=style&index=0&id=55699dd2&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__